import React from 'react';
import { Sidebar } from '../../../components/Sidebar';
import { Header } from '../../../components/Header';
import { PlayCircleIcon, DownloadIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export function VideoPreview() {
  const navigate = useNavigate();
  return <div className="flex w-full min-h-screen bg-gray-50" data-id="element-1960">
      <Sidebar data-id="element-1961" />
      <main className="flex-1" data-id="element-1962">
        <Header data-id="element-1963" />
        <div className="px-6 py-8" data-id="element-1964">
          <div className="max-w-4xl mx-auto" data-id="element-1965">
            <h1 className="text-2xl font-semibold text-gray-800 mb-2" data-id="element-1966">
              Preview & Download
            </h1>
            <p className="text-gray-600 mb-6" data-id="element-1967">
              Review your video and download when ready
            </p>

            <div className="space-y-6" data-id="element-1968">
              <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-1969">
                <h3 className="font-medium text-gray-800 mb-4" data-id="element-1970">
                  Video Preview
                </h3>
                <div className="flex justify-center" data-id="element-1971">
                  <div className="w-full max-w-md h-96 bg-gradient-to-br from-green-100 to-green-200 rounded-lg flex items-center justify-center border-2 border-gray-200 relative" data-id="element-1972">
                    <PlayCircleIcon className="text-gray-600" size={64} data-id="element-1973" />
                    <div className="absolute bottom-4 left-4 right-4 bg-black/50 backdrop-blur-sm rounded px-3 py-2 flex items-center justify-between" data-id="element-1974">
                      <div className="flex items-center space-x-2" data-id="element-1975">
                        <PlayCircleIcon className="text-white" size={20} data-id="element-1976" />
                        <div className="w-32 h-1 bg-gray-400 rounded-full" data-id="element-1977">
                          <div className="w-0 h-1 bg-white rounded-full" data-id="element-1978"></div>
                        </div>
                      </div>
                      <span className="text-white text-xs" data-id="element-1979">0:00 / 0:06</span>
                    </div>
                  </div>
                </div>
                <p className="text-sm text-gray-600 text-center mt-4" data-id="element-1980">
                  Click to play video preview
                </p>
              </div>

              <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-1981">
                <h3 className="font-medium text-gray-800 mb-4" data-id="element-1982">
                  Video Information
                </h3>
                <div className="grid grid-cols-2 gap-4" data-id="element-1983">
                  <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-1984">
                    <p className="text-sm text-gray-600 mb-1" data-id="element-1985">
                      Animation Style
                    </p>
                    <p className="font-semibold text-gray-800" data-id="element-1986">Zoom In</p>
                  </div>
                  <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-1987">
                    <p className="text-sm text-gray-600 mb-1" data-id="element-1988">Duration</p>
                    <p className="font-semibold text-gray-800" data-id="element-1989">6 seconds</p>
                  </div>
                  <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-1990">
                    <p className="text-sm text-gray-600 mb-1" data-id="element-1991">Resolution</p>
                    <p className="font-semibold text-gray-800" data-id="element-1992">
                      1080 x 1080 px (1:1)
                    </p>
                  </div>
                  <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-1993">
                    <p className="text-sm text-gray-600 mb-1" data-id="element-1994">File Size</p>
                    <p className="font-semibold text-gray-800" data-id="element-1995">3.5 MB</p>
                  </div>
                </div>
              </div>

              <div className="bg-green-50 border border-green-200 rounded-lg p-4" data-id="element-1996">
                <h4 className="font-medium text-green-900 mb-2" data-id="element-1997">
                  Ready to Download
                </h4>
                <p className="text-sm text-green-800" data-id="element-1998">
                  Your video is optimized for social media platforms and ready
                  to use in your campaigns.
                </p>
              </div>

              <div className="flex justify-center space-x-4" data-id="element-1999">
                <button className="px-8 py-3 bg-blue-500 text-white rounded-md hover:bg-blue-600 font-medium transition-colors flex items-center" data-id="element-2000">
                  <DownloadIcon size={20} className="mr-2" data-id="element-2001" />
                  Download Video
                </button>
                <button onClick={() => navigate('/creative-customizer')} className="px-6 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-2002">
                  Create Another
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>;
}